import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { ScheduleSettingsModel } from '@user/store/closingRequirements/typings'
import { unwrapResult } from '@reduxjs/toolkit'
import { getSchedulingRequirementSettings } from '@user/store/closingRequirements/api'

export const useGetScheduleRequirementsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [scheduleRequirements, setScheduleRequirements] =
    useState<ScheduleSettingsModel>()

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')

        const result = await dispatch(getSchedulingRequirementSettings())

        if (mounted) {
          if (getSchedulingRequirementSettings.fulfilled.match(result)) {
            setScheduleRequirements(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { scheduleRequirementsStatus: status, scheduleRequirements }
}
